export default "__VITE_ASSET__3bc3ba15__"